/* ai-answer-title.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./ai-answer-title.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { cx } from '@atlaskit/css';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Flex } from '@atlaskit/primitives/compiled';
import { getFrontendExperiment } from '@atlassian/search-experiment';
import { useAIAnswerContext } from './ai-answer-context';
import { ReadingAidsOptions } from './reading-aids-options';
var styles = {
  titleWrapper: "_1bah1yb4 _4cvr1h6o _19pkv47k _2hwx1ejb _18u01ejb",
  titleWrapperUpdateStyles: "_19pkutpp _2hwxpxbi _18u0pxbi",
  definitionTitle: "_11c8nbxd _syazi7uo"
};
export var AIAnswerTitle = function AIAnswerTitle() {
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes,
    baseQuery = _useAIAnswerContext.baseQuery;
  var query = commonAttributes.query;
  var _getFrontendExperimen = getFrontendExperiment({
      abTestId: 'kd_definitions_ux_uplift_exp'
    }),
    serveDefinitionsUXExp = _getFrontendExperimen.serveExperiment;
  var serveDefinitionUXUpdates = serveDefinitionsUXExp && fg('kd_definitions_ux_uplift_exp_gate');
  return /*#__PURE__*/React.createElement(Flex, {
    xcss: cx(styles.titleWrapper, serveDefinitionUXUpdates && styles.titleWrapperUpdateStyles)
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.definitionTitle
  }, baseQuery ? baseQuery : query), /*#__PURE__*/React.createElement(ReadingAidsOptions, null));
};